import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";
import { firebaseLogout } from "../actions/userAction";
export interface UserState {
  isUserAuthenticated: boolean;
  role: string;
  userId: string;
  hasAdminAccess: boolean;
  hasMasterAdminAccess: boolean;
  hasHealthCoachAccess: boolean;
  hasClinicalAssistantAccess: boolean;
}

const initialState: UserState = {
  isUserAuthenticated: false,
  role: "",
  userId: "",
  hasAdminAccess: false,
  hasMasterAdminAccess: false,
  hasHealthCoachAccess: false,
  hasClinicalAssistantAccess: false,
};

const getIntialState = (): UserState => {
  let isUserAuthenticated = false;
  let userId = "";
  let role = "";
  let hasAdminAccess = false;
  let hasMasterAdminAccess = false;
  let hasHealthCoachAccess = false;
  let hasClinicalAssistantAccess = false;
  const token = localStorage.getItem("cadence-access-token") || "";
  const refreshToken = localStorage.getItem("cadence-refresh-token") || "";
  if (token && refreshToken) {
    try {
      const decoded: any = jwt_decode(token);
      const decodedRefresh: any = jwt_decode(refreshToken);

      const accessTokenUserId = decoded.sub || decoded.id;
      const refreshTokenUserId = decodedRefresh.sub || decodedRefresh.id;

      if (accessTokenUserId !== refreshTokenUserId) {
        firebaseLogout();
        localStorage.clear();
        return { ...initialState };
      }

      isUserAuthenticated = true;
      userId = accessTokenUserId;
      // Backward compat: use role from JWT if present (old tokens)
      if (decoded.role) {
        role = decoded.role;
        hasAdminAccess = ["master_admin", "admin"].includes(role);
        hasMasterAdminAccess = ["master_admin"].includes(role);
        hasHealthCoachAccess = ["coach"].includes(role);
        hasClinicalAssistantAccess = ["clinical_assistant"].includes(role);
      }
    } catch (err) {}
  }
  return {
    ...initialState,
    isUserAuthenticated,
    userId,
    role,
    hasAdminAccess,
    hasMasterAdminAccess,
    hasHealthCoachAccess,
    hasClinicalAssistantAccess,
  };
};

export const userSlice = createSlice({
  name: "user",
  initialState: getIntialState,
  reducers: {
    setUserAuth: (
      state,
      action: PayloadAction<{
        authenticated: boolean;
        role: string;
        userId: string;
      }>
    ) => {
      state.role = action.payload.role;
      state.userId = action.payload.userId;
      state.isUserAuthenticated = action.payload.authenticated;
      state.hasAdminAccess = ["master_admin", "admin"].includes(
        action.payload.role
      );
      state.hasMasterAdminAccess = ["master_admin"].includes(
        action.payload.role
      );
      state.hasHealthCoachAccess = ["coach"].includes(action.payload.role);

      state.hasClinicalAssistantAccess = ["clinical_assistant"].includes(
        action.payload.role
      );
    },
    setRole: (state, action: PayloadAction<string>) => {
      state.role = action.payload;
      state.hasAdminAccess = ["master_admin", "admin"].includes(
        action.payload
      );
      state.hasMasterAdminAccess = ["master_admin"].includes(action.payload);
      state.hasHealthCoachAccess = ["coach"].includes(action.payload);
      state.hasClinicalAssistantAccess = ["clinical_assistant"].includes(
        action.payload
      );
    },
    reset: () => initialState,
  },
});

export const { setUserAuth, setRole, reset } = userSlice.actions;

export default userSlice.reducer;
